// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export function decodeIdTokenPayload(idToken) {
    const parts = idToken.split(".");
    if (parts.length !== 3)
        return null;
    try {
        const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
        const json = decodeURIComponent(atob(padded)
            .split("")
            .map(c => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
            .join(""));
        return JSON.parse(json);
    }
    catch {
        return null;
    }
}
